import { SvgIcon, SvgIconProps } from "@mui/material";

const DashboardIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path
      d="M4.88889 12.8889H10.2222C10.7111 12.8889 11.1111 12.4889 11.1111 12V4.88889C11.1111 4.4 10.7111 4 10.2222 4H4.88889C4.4 4 4 4.4 4 4.88889V12C4 12.4889 4.4 12.8889 4.88889 12.8889ZM4.88889 20H10.2222C10.7111 20 11.1111 19.6 11.1111 19.1111V15.5556C11.1111 15.0667 10.7111 14.6667 10.2222 14.6667H4.88889C4.4 14.6667 4 15.0667 4 15.5556V19.1111C4 19.6 4.4 20 4.88889 20ZM13.7778 20H19.1111C19.6 20 20 19.6 20 19.1111V12C20 11.5111 19.6 11.1111 19.1111 11.1111H13.7778C13.2889 11.1111 12.8889 11.5111 12.8889 12V19.1111C12.8889 19.6 13.2889 20 13.7778 20ZM12.8889 4.88889V8.44444C12.8889 8.93333 13.2889 9.33333 13.7778 9.33333H19.1111C19.6 9.33333 20 8.93333 20 8.44444V4.88889C20 4.4 19.6 4 19.1111 4H13.7778C13.2889 4 12.8889 4.4 12.8889 4.88889Z"
      fill="currentColor"
    />
  </SvgIcon>
);

export default DashboardIcon;
